import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import InvoiceCollection from '@/modules/myInvoices/entities/InvoiceCollection'
import type { Order, OrderBy } from '@/modules/myInvoices/types/InvoiceOrder'
import AxiosFactory from '@/entities/security/AxiosFactory'
import { GET_INVOICE_URL } from '../invoice/endpoints'
export default class MyInvoicesApi {
  async loadInvoices({
    startnumber,
    numreturned,
    orderby,
    order,
    status,
  }: {
    startnumber: number
    numreturned: number | string
    orderby: OrderBy
    order: Order
    status?: string
  }) {
    try {
      let url = `${GET_INVOICE_URL}?start=${startnumber}&number=${numreturned}&orderby=${orderby}&order=${order}`
      if (status) url += `&status=${status}`
      const response = await AxiosFactory.createAxiosInstance().get(url)
      return new InvoiceCollection(response.data)
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
